// ブランド資産は「ベースURL + 固定ファイル名」の規約で配信する。
// 同じ規約を PWA manifest 側でも使うため、変更時は scripts/generate-branding.js も合わせること。
type BrandingInput = {
  serviceName: string | undefined;
  assetsBaseUrl: string | undefined;
};

export type Branding = {
  serviceName: string;
  logoUrl: string;
};

const requireEnv = (name: string, value: string | undefined): string => {
  if (!value) {
    throw new Error(`環境変数 ${name} が未設定です。`);
  }

  return value;
};

export const buildBranding = ({
  serviceName,
  assetsBaseUrl,
}: BrandingInput): Branding => ({
  serviceName: requireEnv('REACT_APP_SERVICE_NAME', serviceName),
  // public/index.html は同じ env を文字列置換で差し込むだけで正規化できない。
  // ここで整形すると HTML と JS で同じ env が違う URL になるため、値の妥当性は
  // scripts/generate-branding.js がビルド時に検証する。
  logoUrl: `${requireEnv(
    'REACT_APP_BRAND_ASSETS_BASE_URL',
    assetsBaseUrl,
  )}/logo.png`,
});

export const branding = buildBranding({
  serviceName: process.env.REACT_APP_SERVICE_NAME,
  assetsBaseUrl: process.env.REACT_APP_BRAND_ASSETS_BASE_URL,
});
